import React from 'react';
import classNames from 'classnames';
import css from './IncreaseEmailLimitModal.module.css';
import { Button } from '@mm/components';
import { ArrowDownOutlined, CloseOutlined } from '@ant-design/icons';
import { ModalInstanceProps } from '../interfaces';
import { ReactComponent as InfoIcon } from './info-art.svg';
import { ReactComponent as SendIcon } from './send-mail-art.svg';
import { IIncreaseLimitModal } from '@mm/state/modules/modalsState/props';

type Props = IIncreaseLimitModal & ModalInstanceProps;

export const IncreaseEmailLimitModal: React.FC<Props> = ({
  className,
  onSubmit = async () => {},
  closeModal,
}) => {
  const handleReject = async () => {
    closeModal();
  };

  const handleSubmit = () => {
    onSubmit();
  };

  return (
    <div className={classNames(className, css.container)}>
      <div className={classNames(css.modal, { [css.error]: false })}>
        <div className={css.modalContent}>
          <span className={css.close} onClick={handleReject}>
            <CloseOutlined />
          </span>
          <h1 className={css.title}>
            Professional workspace emails have higher deliverability and sending
            capacity
          </h1>

          <span className={css.subtitle}>
            Email accounts ending with @gmail.com are limited to sending 5
            emails per day.
          </span>

          <div className={css.blocks}>
            <div className={css.block}>
              <span className={css.blockIcon}>
                <img src="" alt="" />
                <InfoIcon />
              </span>
              <span className={css.blockTitle}>Why does this happen?</span>
              <p className={css.blockText}>
                Gmail.com domains are super sensitive to outbound emailing. This
                limit protects your Gmail account from being flagged as spam.
              </p>
            </div>
            <div className={css.block}>
              <span className={css.blockIcon}>
                <img src="" alt="" />
                <SendIcon />
              </span>
              <span className={css.blockTitle}>How do I increase this?</span>
              <p className={css.blockText}>
                Connecting a professional email account will increase your
                delivery capacity. Workspace domains have tolerance for targeted
                outbound emails.
                <ArrowDownOutlined />
              </p>
            </div>
          </div>

          <div className={css.actions}>
            <Button color="transparent-no-shadow" onClick={handleReject}>
              Cancel
            </Button>
            <Button onClick={handleSubmit}>Connect my business email</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
